/* Add p_appEnt, kt-notes Jul 11, 2026 */
<template lang="pug">
	div(v-if="col.field == 'notes'")
		kt-notes(v-if="d_editNotes" :key="p_recData[p_appEnt.idKey]" :p_recordContext="p_appEnt.idKey" :p_recordId="p_recData[p_appEnt.idKey]" p_mode="edit" 
		@close="m_closeNotes" @savedNotes="$emit('savedNotes', $event)"  )
	div(v-else-if="c_allowEdit")
		div(v-if="['oppr','proj','acct','extr','cmpt','team'].includes(col.datatype)")
			kt-select(:p_appEntKey="col.datatype" :p_currentVal="d_recData[col.field]" :p_readOnly="false" :p_enableCreate="false"
				@change="m_entityChange($event,col)"  )
			div(v-else-if="col.datatype=='time'" class="cellEdit"  )
				b-form-timepicker(:id="col.field" v_model="d_recData[col.field]"  :value="d_recData[col.field]" locale="en" @input="m_inputTime($event,col)")
			div(v-else-if="col.datatype=='url'" class="cellEdit"  )
				b-form-input(:id="col.field" type="text" v_model="d_recData[col.field]"  @change="m_dataChange(col)")
			div(v-else-if="col.datatype=='checkbox'" class="form-group grid-item"  style="margin-top:35px;")
				b-form-checkbox(:id="col.field" size="sm" type="checkbox" v-model="d_recData[col.field]"  :value="Y" unchecked-value="N" @change="m_dataChange(col)") 
			div(v-else-if="col.datatype=='money'" class="cellEdit" )
				b-input-group(size="sm" prepend="$")
					b-form-input( :id="col.field"  :value="d_recData[col.field]?Number(d_recData[col.field]).toLocaleString():''"   @change="m_dataChange(col)" style="width:50px;")
			div(v-else-if="col.multiSelect" class="form-group grid-item"  style="height:30px;width:504px;padding-right:8%;")
				kt-custom-multiselect(:id="col.field" size="sm" :p_options="c_selectOptions" :p_value="d_recData[col.field]" @input="m_multiSelectInput($event,col)")
			div(v-else-if="col._refId" class="selectClass cellEdit")
				b-form-select( :id="col.field" :value="d_recData[col.field]" v_model="d_recData[col.field]" :options="col._refData" :value-field="col._refId" :text-field="col._refName" @change="m_dataChange(col)" )
			div(v-else-if="col._refData" class="selectClass cellEdit")
				b-form-select(:id="col.field" :value="d_recData[col.field]" v_model="d_recData[col.field]" :options="col._refData" value-field="id" text-field="name" @change="m_dataChange(col)" )
			div(v-else-if="col.listOfValues" class="cellEdit"  )
				b-form-select(:id="col.field" size="sm" :value="d_recData[col.field]" :options="c_selectOptions"  @change="m_dataChange(col)")
			div(v-else-if="col.datatype=='tel'" class="cellEdit")
				kt-com-fld(p_mode="edit" :id="col.field" size="sm" typ="p" :value="d_recData[col.field]" v_model="d_recData[col.field]"  @input="m_comFieldInput($event,col)")
			div(v-else class="grid-item cellEdit")
				b-form-input(:id="col.field" size="sm" :type="col.datatype" :value="d_recData[col.field]" v_model="d_recData[col.field]"  @change="m_dataChange(col)")
</template>
<script>
import util, {kbdpAlert} from "@/utils/util.js";
import {refData} from "@/utils/ref-data.js";
import {fn_simpleSearch,settings as api} from "@/utils/api.js";
import KTcustomMultiSelect from "@/components/Ctrl/KT-CustomMultiSelect.vue";
export default {
	name: "kt-table-columnEdit",
	components: {
			"kt-custom-multiselect":KTcustomMultiSelect,
			"kt-notes": () =>import("@/components/Ctrl/KT-Notes.vue"),
	},
	created() {if(this.p_recData) this.d_recData=this.p_recData;
				if(this.p_col) this.col=this.p_col;
			let params = {
				context: 'allRecords',
				query: null,
				filter: null,
				};
				
				var allOptions=[];
				this.d_customFields.forEach(p_col=>{
					if(p_col.listOfValues) allOptions=[...allOptions,...p_col.listOfValues];
					});
					
				const entOptions=['opportunities','accounts','projects','contacts','competitors','team'];
				var commonOptions=allOptions.filter(v => entOptions.includes(v.toLowerCase()));
				if(commonOptions.length>0){
					fn_simpleSearch(params).then(resp => {
						resp.searchResult.forEach(s=>{
						this.d_optionValues.push({recType:s.recType,value:s.recNo,text:s.recName});
								});
					});
				}
				
				console.log('p_appEnt',this.p_appEnt);
				console.log('p_prntRecKey',this.p_prntRecKey);
				console.log('p_recData',this.p_recData);
				

	
	},
	mounted() {},
	data() {
		return {
			d_recData:{},
			d_customFields:refData.customFields.filter(c=>(c.context==this.p_prntRecKey)),
			d_optionValues:[],
			d_disallowedColumns:['designerAccounts','competitors','assignedTeamMembers','externalContacts','taskAssignees',
								'createdById','createdUTC','updatedBy','updatedUTC','psqft'],
			col:{},
			d_editNotes:true,
		};
	},
	props: {
		p_recData: Object,
		p_prntRecKey: String,
		p_col:Object,
		p_appEnt:Object,
	},
	computed: {
			c_tblStyle() {
			return this.p_style?this.p_style:"display:block;flex: 0 0 50%;";
			},
			c_allowEdit(){return !this.d_disallowedColumns.includes(this.col.field);},
			c_selectOptions(){
						var returnVal;
						var col=this.col;
						console.log("In c_selectOptions");
						console.log(col);
						var map=new Map([['opportunities','oppr'],
										['projects','proj'],
										['accounts','acct'],
										['contacts','extr'],
										['competitors','cmpt'],
										['team','team']
										]);
					if(col.listOfValues[0]){
						var LOV=col.listOfValues[0].toLowerCase();
						if(map.has(LOV))
							returnVal=this.d_optionValues.filter(v=>(v.recType==map.get(LOV)));
						else returnVal=col.listOfValues;
						}
			return returnVal;
						
			},
	},
	methods: {
		m_entityChange(e,col){
				var map=new Map([['oppr','opportunity'],
								['proj','project'],
								['acct','account'],
								['extr','externalContact'],
								['cmpt','competitor'],
								['team','teamMember']
								]);
				var entityId=map.get(col.type)+'Id';
				var entityNo=map.get(col.type)+'No';
				var entityName=map.get(col.type)+'Name';
				this.d_recData[col.name]={type:col.type, id:e[entityId], no:e[entityNo],name:e[entityName], profPic: col.type=='team'};
				this.$emit('change',this.d_recData);
		},
		m_dataChange(col){
			window.sessionStorage.setItem('unsaved-changes', true);
				if(col.type=='checkbox')
					this.d_recData[col.field]=document.getElementById(col.field).checked?'Y':'N'
				else 
				if(col.type=='money'){
					var moneyVal=document.getElementById(col.field).value.split(',').join('');
					this.d_recData[col.field]=moneyVal;
					}
				else
					this.d_recData[col.field]=document.getElementById(col.field).value;
					
				this.$emit('change',this.d_recData);
				},
		m_inputTime(e,col){
			window.sessionStorage.setItem('unsaved-changes', true);
			this.d_recData[col.field]=e;
			this.$emit('change',this.d_recData);
		},
		m_multiSelectInput(e,col){
			//this.d_recData[col.field]=JSON.stringify(e);
			window.sessionStorage.setItem('unsaved-changes', true);
			this.d_recData[col.field]=e;
			this.$emit('change',this.d_recData);
		},
		m_closeNotes(e){
		   this.d_editNotes=false;
		   this.$emit('closeNotes');
		}
	},
	watch: {
	p_recData(nv,ov){
			this.d_recData=nv;
			this.d_customFields.forEach(col=>{
					console.log(col.field);
					if(this.p_col.type=='checkbox' &&
						this.d_recData[col.field]=='Y'){
							document.getElementById(col.field).checked = true;
							}
					});
			},
	p_col(nv,ov){console.log(nv);this.col=nv;},
	
	}
};
</script>
<style scoped lang="less">
hr{border: 0.1px solid;}
.grid-container {
  display: grid;
  grid-template-columns: auto auto;
}
.grid-item {
  border: none; 
  font-size: 15px;
  text-align: left;
}
fieldset {
-webkit-border-radius: 8px;
-moz-border-radius: 8px;
border-radius: 8px;
}
summary {list-style: none}
summary::-webkit-details-marker {display: none; }
details summary::before { 
  content:"🡒"; 
  color: #1E90FF; 
  /* you can style it however you want, use background-image for example */
}

/* By using [open] we can define different styles when the disclosure widget is open */
details[open] summary::before { 
  content:"🠣";  /*"🡑"*/ 
  color: #1E90FF; 
}
.primary{color:#007bff;}
.selectClass {
    max-height: 100px  !important;
    overflow-y: auto   !important;
    min-height1: 80px   !important;
	}
.cellEdit{
		border-style: outset;
		border-right:none;
}
</style>